import { configureStore } from "@reduxjs/toolkit";

import popupReducer from "./slices/popupCenterSlice";
import authenticationSlice from "./slices/authenticationSlice";
import doctorSlice from "./slices/doctorSlice";
import patientSlice from "./slices/patientSlice";
import priceSlice from "./slices/priceSlice";
import postPaySlice from "./slices/postPaySlice";
import ticketSlice from "./slices/ticketSlice";

export const store = configureStore({
  reducer: {
    popup: popupReducer,
    auth: authenticationSlice,
    doctor: doctorSlice,
    patient: patientSlice,
    price: priceSlice,
    postpay: postPaySlice,
    ticket: ticketSlice,
  },
});
